module.exports = __webpack_public_path__ + "static/media/plass_begin_student.9d85cf26.png";